import {EventEmitter} from 'eventemitter3';

import EVENTS from './EVENTS';
/**
 * **The majority of the functionality of `Analytics` is inherited from `eventemitter3.EventEmitter`.**
 */
export default class Analytics extends EventEmitter {
  /**
   * @param {{listeners: {}}} configuration
   * @param {{debug: boolean}} options
   */
  constructor(
    configuration = {listeners: {}},
    options = {debug: process.env.NODE_ENV !== 'production'}
  ) {
    super();
    this.options = options;
    this.EVENTS = EVENTS;
    this.listeners = configuration.listeners;
    Object.keys(this.listeners).forEach((name) => {
      this.bindListener(name, this.listeners[name]);
    });
    this.emit(EVENTS.START);
  }

  isDebugMode() {
    return this.options.debug;
  }

  bindListener(name, listener) {
    Object.keys(listener.events).forEach((event) => {
      let handler;
      /**
       * If we're in debug mode we trigger a log message before the listener's handler AND
       * expose the provider-encountered error to the `console` (where applicable).
       */
      if (this.isDebugMode()) {
        handler = (metadata) => {
          logger.debug(`[ANALYTICS] : ${name} : ${event} : `, JSON.stringify(metadata, null, 2));
          this.listeners[name].events[event](metadata);
        };
      } else {
        /**
         * *IMPORTANT*
         * The call to a listener's handler should be wrapped in a try/catch to ensure calls to
         * listener-bound methods do not throw and potentially alter a user's session.
         */
        handler = (metadata) => {
          try {
            this.listeners[name].events[event](metadata);
          } catch (e) {
            // intentional error suppression
          }
        };
      }
      this.addListener(event, handler);
    });
  }
}
